<template>
  <div class="grid-x grid-padding-x align-center">
    <div class="cell medium-12 large-3 small-order-2 large-order-1">
      <degree-partnerships-search-filters-component
        :nonce="nonce"
        :apiUrls="apiUrls"
        ref="searchFiltersComponentRef"
        @onSubmit="submit"
        is-on-results-page="true"
        base-page-path="/transfer-options/search-programs/"
        results-page-path="/transfer-options/search-programs/result-degree-partnerships/"
      >
      </degree-partnerships-search-filters-component>
    </div>

    <div class="cell medium-12 large-9 small-order-1 large-order-2 o-search-result">
      Search Result
      <div class="o-search-results">
        <div class="o-search-results__header s-content-block s-content-block--small">
          <div class="o-search-results__title">
            <h3>Degree Partnerships</h3>
            <div class="o-search-results__button">
              <form id="save-to-pdf-form" target="_blank" method="POST"></form>
              <button
                type="button"
                class="a-button a-button--small a-button--primary-outline"
                @click="downloadPdf"
              >
                Save to PDF
              </button>
              <button type="button" class="a-button a-button--small" @click="newSearch">
                New Search
              </button>
            </div>
          </div>
        </div>

        <div class="s-content-block s-content-block--small">
          <div class="o-search-result__table-total-page">
            <div class="text-center medium-text-left">
              {{ pageFrom }} to {{ pageTo }} of {{ totalAgreements }} matches <br />
            </div>
            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">
                      {{ page }}
                    </button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
          <div class="o-search-results__table-wrapper">
            <div
              class="o-search-results__table"
              v-if="
                searchResponse.agreements != null && _.get(searchResponse, 'agreements.length') > 0
              "
            >
              <!-- Headings -->
              <div class="o-search-results__table-header">
                <div class="grid-x">
                  <div class="cell small-2"><strong>Institution</strong></div>
                  <div class="cell small-2"><strong>Partnership Description</strong></div>
                  <div class="cell small-2"><strong>Institutional Credential</strong></div>
                  <div class="cell small-4"><strong>Specialization</strong></div>
                  <div class="cell small-2"><strong>Conferrer</strong></div>
                </div>
              </div>

              <div
                class="o-search-results__table-row degree-partnerships"
                v-for="agreement in searchResponse.agreements"
                :key="agreement.id"
              >
                <div class="grid-x">
                  <div class="cell small-12">
                    <strong>{{ agreement.name }}</strong>
                  </div>
                </div>

                <div
                  class="grid-x"
                  v-for="partnership in agreement.partnerships"
                  :key="partnership.dpInstitutionId"
                >
                  <!-- Institution -->
                  <div class="cell small-2 nice">
                    <div class="flex-container">
                      <div
                        class="o-search-results__logo"
                        :data-tooltip="partnership.institutionName"
                      >
                        <img :src="`${logosUrl}/${partnership.globalInstitutionId}_icon.png`" />
                      </div>
                      <span>{{ partnership.code }} ({{ partnership.province }})</span>
                    </div>
                  </div>

                  <!-- Partnership Description -->
                  <div class="cell small-2">
                    <div class="flex-container">
                      <span
                        ><a
                          target="_blank"
                          rel="noopener noreferrer"
                          :href="partnership.dpInstitutionUrl"
                          >info</a
                        ></span
                      >
                    </div>
                  </div>

                  <!-- Institutional Credential -->
                  <div class="cell small-2">
                    <div class="flex-container">
                      <span>{{ partnership.dpInstCredName }}</span>
                    </div>
                  </div>

                  <!-- Specialization -->
                  <div class="cell small-4">
                    <div class="flex-container">
                      <span>{{ partnership.dpInstitutionSpecialty }}</span>
                    </div>
                  </div>

                  <!-- Conferrer -->
                  <div class="cell small-2">
                    <div class="flex-container">
                      <span>{{ partnership.dpInstitutionIsConferring ? 'Yes' : '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h6 v-else-if="_.get(searchResponse, 'agreements.length') == 0">
              There are no transfer agreements for that search. Please try again.
            </h6>
          </div>
          <div class="o-search-result__table-page">
            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">
                      {{ page }}
                    </button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import axios from 'axios'
import _ from 'lodash'
import DegreePartnershipsSearchFiltersComponent from './DegreePartnershipsSearchFiltersComponent.vue'
import Paginate from 'vuejs-paginate-next'

const props = defineProps({
  nonce: { type: String, required: true },
  logosUrl: { type: String, required: true },
  apiUrls: { type: Object, required: true },
})

const searchFiltersComponentRef = ref(null)

const searchResponse = ref({ agreements: null })
const searchRequestCancelToken = ref(null)
const pdfRequestCancelToken = ref(null)
const pageLength = ref(null)
const pageFrom = ref(null)
const pageTo = ref(null)
const currentPage = ref(1)
const totalPages = ref(0)
const totalAgreements = ref(0)
const currentFilterData = ref({})

const goToFirstPage = () => {
  currentPage.value = 1
}

const goToLastPage = () => {
  currentPage.value = totalPages.value
}

watch(currentPage, (newCurrentPage, old) => {
  if (newCurrentPage === old) return
  if (newCurrentPage === 1 && old === null) return

  const data = _.clone(currentFilterData.value)
  _.set(data, 'pageNumber', newCurrentPage)
  submit(data)
})

const submit = (data) => {
  currentFilterData.value = _.clone(data)
  searchRequestHandler(
    '/wp-json/bctg-search/degree-partnerships/agreements',
    currentFilterData.value,
  )
}

const searchRequestHandler = (path, params) => {
  if (searchRequestCancelToken.value) {
    searchRequestCancelToken.value.cancel()
  }

  searchRequestCancelToken.value = axios.CancelToken.source()
  searchResponse.value.agreements = null

  document.body.classList.add('js-is-searching')
  $('html, body').animate({ scrollTop: $('.js-header').offset().top + 200 }, '400')

  axios
    .post(`${path}?_wpnonce=${props.nonce}`, params, {
      cancelToken: searchRequestCancelToken.value.token,
    })
    .then((response) => searchResponseHandler(response))
}

const searchResponseHandler = (response) => {
  Object.assign(searchResponse.value, response.data)
  document.body.classList.remove('js-is-searching')

  const attributes = {
    currentPage,
    totalPages,
    totalAgreements,
    pageLength,
    pageFrom,
    pageTo,
  }

  Object.keys(attributes).forEach((key) => {
    const value = _.get(searchResponse.value, key)
    if (value !== attributes[key].value) {
      attributes[key].value = value
    }
  })
}

const downloadPdf = (event) => {
  event.preventDefault()

  const saveToPdfFormElement = document.getElementById('save-to-pdf-form')
  saveToPdfFormElement.action = `/wp-json/bctg-search/degree-partnerships/agreements/pdf?_wpnonce=${props.nonce}`
  saveToPdfFormElement.innerHTML = ''

  _.forEach(currentFilterData.value, (paramValue, paramName) => {
    const newInput = document.createElement('input')
    newInput.type = 'hidden'
    newInput.id = paramName
    newInput.name = paramName
    newInput.value = paramValue
    saveToPdfFormElement.append(newInput)
  })

  saveToPdfFormElement.submit()
}

const newSearch = () => {
  searchFiltersComponentRef.value.newSearch()
}
</script>
